<script>
import {formatDirectINSEEaddress} from "../../mixins/insee";

export default {
  props: {
    record: {
      type: Object,
      default: null
    }
  },
  methods: {
      formatDirectINSEEaddress,
      emitSelected() {
        this.$emit('selected', this.record);
      }
    }
};
</script>

<template>
  <b-container @click="emitSelected">
    <b-row class="mb-2">
      <b-col>
        <b-button variant="light" class="w-100 rounded border bg-white px-3 py-2">
          <div class="d-flex flex-row align-items-center">
            <div class="bg-gray-200 flex items-center justify-center mr-3">
              <b-icon icon="building" style="width: 22px; height: 22px;" />
            </div>

            <div>
              <b-container>
                <b-row>
                  <h6 class="text-primary font-semibold pb-0 mb-0" style="font-size: 14px;">
                    {{
                      record?.fields?.denominationunitelegale ??
                      record?.fields?.nomunitelegale ??
                      record?.uniteLegale?.denominationUniteLegale ??
                      record?.uniteLegale?.nomUniteLegale ?? ''
                    }}
                  </h6>
                </b-row>
                <b-row><span class="text-muted" style="font-size: 12px;">{{ record?.fields?.classeetablissement ?? record?.uniteLegale?.activitePrincipaleUniteLegale }}</span></b-row>
                <b-row> <span class="text-muted" style="font-size: 12px;">{{ record?.fields?.adresseetablissement ?? formatDirectINSEEaddress(record, true) }}</span></b-row>
              </b-container>
            </div>
          </div>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
  .card-body {
    padding:  0.75rem 1.25rem;
  }
  .text-xs {
    font-size: 0.8rem;
  }
  .bg-gray-200 {
    background-color: var(--gray-200);
    border-radius: 50%;
    padding: 0.5rem;
    height: 2.5rem;
    width: 2.5rem
  }
</style>